import { API_BASE_URL, API_PATHS, getApiPaths } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class StudentService {

  static getStudent(item = {}) {
    const user = JSON.parse(localStorage.getItem("user"));
    const dynamicPaths = getApiPaths(user?.data?.roleId?.name);

    const params = new URLSearchParams();

    params.append("limit", item?.limit || 100);
    params.append("page", item?.page || 1);

    if (item?.id) {
      params.append("id", item.id);
    }

    if (item?.standardId) {
      params.append("standardId", item.standardId);
    }

    if (item?.sectionId) {
      params.append("sectionId", item.sectionId);
    }

    const api = `${API_BASE_URL}${dynamicPaths.getStudent}?${params.toString()}`;

    return axiosInstance.get(api);
  }




  static getallchild(item = {}) {
    const params = new URLSearchParams();

    if (item?.parentId) {
      params.append("parentId", item.parentId);
    }

    const api = `${API_BASE_URL}${API_PATHS.getallChild}?${params.toString()}`;

    return axiosInstance.get(api);
  }





  static addStudent(data) {
    return axiosInstance.post(
      `${API_BASE_URL}${API_PATHS.addStudent}`,
      data,
      { headers: { "Content-Type": "application/json" } }
    );
  }

  static updateStudent(data) {

    let api = '';
    api = `${API_BASE_URL}${API_PATHS.editStudent}`;
    return axiosInstance
      .put(api, data)

  }
  static deleteStudent(id) {
    let api = '';

    api = `${API_BASE_URL}${API_PATHS.deleteStudent}?studentId=${id}`;

    return axiosInstance
      .delete(api)
  }

}

export default StudentService;
